/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_SubtitleInputs */

const cs_settings_office_subtitle = /** @type {(inputs: Settings_Office_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sdílená identita RK — název, časové pásmo, značka, zastřešující firma a AI. Pobočky a klíče k portálům jsou jinde.`)
};

const en_settings_office_subtitle = /** @type {(inputs: Settings_Office_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shared identity of this RK — name, timezone, brand, umbrella company, and AI. Branches and portal keys are separate.`)
};

/**
* | output |
* | --- |
* | "Shared identity of this RK — name, timezone, brand, umbrella company, and AI. Branches and portal keys are separate." |
*
* @param {Settings_Office_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_subtitle = /** @type {((inputs?: Settings_Office_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_subtitle(inputs)
	return cs_settings_office_subtitle(inputs)
});